
/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 生成序号 */
    id: 'id',

    /** 报表名称 */
    name: 'templateName',

    /** 用途 */
    purpose: 'purpose',

    /** 使用条件 */
    condition: 'query',

    /** 操作人 */
    operator: 'createUserName',

    /** 生成时间 */
    createTime: 'gmtCreate',

};

export const ExportStatus = {
    /** 正在导出 */
    IN_THE_EXPORT: '0',

    /** 导出成功 */
    EXPORT_SUCCESS: '1',

    /** 导出失败 */
    EXPORT_FAIL: '2'
};